export default {"src":"/_next/static/media/Cardiomyopathy.3e277fbf.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};